// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vst_tabs[data-v-02842c59]{overflow-y:auto;width:100%}.vst_tabs[data-v-02842c59]::-webkit-scrollbar{height:6px;width:6px;background-color:#f5f5f5}.vst_tabs[data-v-02842c59]::-webkit-scrollbar-thumb{background-color:var(--primary);border-radius:2px}.vst_tabs[data-v-02842c59]::-webkit-scrollbar-track{background-color:#f5f5f5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
